import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/basic-health/patientConditionReport";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	patientConditionReport: {
		id: "form.patient_condition_report",
		defaultMessage: "Állapotváltozás jelentés"
	},
	description: {
		id: "form.patient_condition_report.description",
		defaultMessage: "Állapotváltozás leírása"
	}
});

const fields: { [key: string]: FieldData } = {
	description: {
		type: "field",
		path: ["description"],
		label: messages.description,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.description }] }]
};

export const node: LeafNode = {
	id: "bh_patientConditionReport",
	value: {
		schemaId: "patientConditionReport",
		title: messages.patientConditionReport,
		validator,
		fieldset,
		applyCurrentDate: true,
		showTimeInput: true,
		returnTo: "status-history"
	}
};
